import React from 'react';
import styled from 'styled-components';

type Size = 'sm' | 'md' | 'lg' | number;
type Color = 'inherit' | 'primary' | 'secondary' | 'success' | 'error';

export const sizeWrapper = {
  sm: '18px',
  md: '24px',
  lg: '30px'
};

export const IconRoot = styled.svg<{ size: Size; color: Color }>`
  width: 1em;
  height: 1em;
  fill: currentColor;
  font-size: ${({ size }) => (typeof size === 'number' ? `${size}px` : sizeWrapper[size])};
  color: ${({ color, theme }) => (color === 'inherit' ? 'inherit' : theme.palette?.[color]?.main)};
`;

export interface Props extends React.HTMLAttributes<SVGSVGElement> {
  children?: React.ReactNode | React.ReactNode[];
  color?: Color;
  size?: Size;
  viewBox?: string;
}

export const Icon: React.FC<Props & React.SVGProps<SVGElement>> = (props: Props) => {
  const { children, color = 'inherit', size = 'md', viewBox = '0 0 24 24', ...rest } = props;

  return (
    <IconRoot viewBox={viewBox} color={color} size={size} {...rest}>
      {children}
    </IconRoot>
  );
};

export default React.memo(Icon);
